var React = require('react');

class EntertainerInput extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  }
  render() {
    return (
      <div>
        <div className="container_fluid main_container second-section login-container" id="content">
          <div className="row-fluid clearfix login-innercontainer">
            <div className="logged-container">
              <div className="login-content">
                <div className="login-title">
                  Enter User Id
                </div>
                <div className="login-types clearfix">
                  <div className="signup-container" style={{"width": "100%"}}>
                    <div className="signup-title" style={{"width": "80%"}}>
                      <input type="text" className="input-email input-box" placeholder="User id" style={{"width": "100%", "text-align": "center"}}/>
                    </div>

                    <div className="signup-title" style={{"width": "80%"}}>
                      <div className="complete item-btn sigin-key" onClick={ this.submit.bind(this) } style={ {"width": "100% !important", "margin-bottom": "2em" } }>Submit</div>
                    </div>
                    <div className="login-error"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }

  submit(response) {
    $('.login-error').text("");
    var email = document.getElementsByClassName('input-email')[0].value;
    if (email == "") {
      $('.login-error').text("Error: User id cannot be blank!");
      $(".input-email").focus();
      return false;
    }
    window.location.href = "/results/" + email;
  }
}

module.exports = EntertainerInput;



// WEBPACK FOOTER //
// ./src/components/EntertainerInput.js